import CoreStyledButton from 'gatsby-theme-core/src/components/button/styled-button';
import styled, { css } from 'styled-components';

export default styled(CoreStyledButton)`
  ${({ $base }) => $base === 'cta' && css`
    border-radius: ${({ theme }) => theme.borderRadius};
    padding-top: .75rem;
    padding-bottom: .75rem;
    font-weight: ${({ theme }) => theme.accentFontWeight || 600};
    line-height: ${({ theme }) => theme.baseLineHeight};
  `}
`;
